import React,{useState, useEffect} from 'react';
import {NavLink, Link} from 'react-router-dom';
import {FiAlignRight,FiXCircle,FiChevronDown } from "react-icons/fi";
import './Navbarmenu.css';
import { baseUrl } from "../Constant";
import axios from "axios";
const Navbarmenu = () => {
    const [isMenu, setisMenu] = useState(false);
    const [isResponsiveclose, setResponsiveclose] = useState(false);
    const toggleClass = () => {
      setisMenu(isMenu === false ? true : false);
      setResponsiveclose(isResponsiveclose === false ? true : false);
    };
    let boxClass = ["main-menu"];
    if(isMenu) {
        boxClass.push('menuq2');
    }else{
        boxClass.push('');
    }

    const [isMenuSubMenu, setMenuSubMenu] = useState(false);
    const toggleSubmenu = () => {
      setMenuSubMenu(isMenuSubMenu === false ? true : false);
    };
    let boxClassSubMenu = ["sub__menus"];
    if(isMenuSubMenu) {
        boxClassSubMenu.push('sub__menus__Active');
    }else {
        boxClassSubMenu.push('');
    }

    const [isMenuSubMenu2, setMenuSubMenu2] = useState(false);
    const toggleSubmenu2 = () => {
      setMenuSubMenu2(isMenuSubMenu2 === false ? true : false);
    };
    let boxClassSubMenu2 = ["sub__menus2"];
    if(isMenuSubMenu2) {
        boxClassSubMenu2.push('sub__menus__Active2');
    }else {
        boxClassSubMenu2.push('');
    }
    const [temp, setTemp] = useState("");
    useEffect(() => {
        const homeUrl = async () => {
            const result = await axios.get(`${baseUrl}/homeUrl`)
            const { data: { Url } } = result
            console.log("test", Url)
            setTemp(Url)
        }
        homeUrl()
    }, []);
    const basePath =
        window.location.hostname === "stagingapps1.lttlx.accenture.com"
            ? "/securitylearnings"
            : "";
    return (
    <header className="header__middle">
        <div className="head-container">
            <div className="row">
                <div className="header__middle__menus">
                    <nav className="main-nav " >
                    {/* Responsive Menu Button */}
                    {isResponsiveclose === true ? <> 
                        <span className="menubar__button" style={{ display: 'none' }} onClick={toggleClass} > <FiXCircle />   </span>
                    </> : <> 
                        <span className="menubar__button" style={{ display: 'none' }} onClick={toggleClass} > <FiAlignRight />   </span>
                    </>}
                    <ul className={boxClass.join(' ')}>
                    <li className="menu-item">
                                    <a
                                        activeClassName="is-active"
                                        className="nav-links"
                                        onClick={() => toggleClass()}
                                        href={temp ? temp : ''}
                                        target="_blank"
                                    >
                                        L&TT Home
                                    </a>
                                </li>
                        <li  className="menu-item" >
                            <NavLink activeClassName='is-active' className="nav-links" onClick={toggleClass} to={`/home`}> Home </NavLink> 
                        </li>
                                <li className="menu-item " > <a
                                    href={`${basePath}/home#security-sdlc`}
                                    className="nav-links"
                                >
                                    Secure SDLC
                                </a> </li>
                                <li className="menu-item " > <a
                                    href={`${basePath}/home#security-types`}
                                    className="nav-links"
                                >
                                    Security Aspects
                                </a> </li>
                        <li onClick={toggleSubmenu} className="menu-item sub__menus__arrows" > <Link className="nav-links" to="#"> Security Offerings <FiChevronDown /> </Link>
                            <ul className={boxClassSubMenu.join(' ')} > 
                                <li className="add-resources"><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links"  to="/security-entry-level"> Entry Level </NavLink> </li>
                                <li className="add-resources"><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/security-laterals">  Laterals </NavLink> </li>
                                <li className="add-resources"><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/security-specialization"> Specialization </NavLink> </li>
                            </ul>
                        </li>
                        <li onClick={toggleSubmenu} className="menu-item sub__menus__arrows" > <Link className="nav-links" to="#"> Security Platforms <FiChevronDown /> </Link>
                            <ul className={boxClassSubMenu.join(' ')} > 
                                <li className="add-resources"><a onClick={toggleClass} activeClassName='is-active' className="nav-links"  href="https://atci.lkm-securitylearnings.accenture.com/Cyberbit/"target="blank" > Cyberbit Security </a> </li>
                            </ul>
                        </li>
                        <li onClick={toggleSubmenu2} className="menu-item sub__menus__arrows" > <Link className="nav-links" to="#"> Additional Resources <FiChevronDown /> </Link>
                            <ul className={boxClassSubMenu2.join(' ')} > 
                                <li className="add-resources"> <a onClick={toggleClass} activeClassName='is-active' className="nav-links" href="https://in.accenture.com/securitycommunity/securityacademy/" target="_blank"> Security Academy </a> </li>
                                <li className="add-resources"><a onClick={toggleClass} activeClassName='is-active' className="nav-links" href="https://in.accenture.com/protectingaccenture/client-data-protection/secure-coding-checklists/" target="_blank"> Secure Coding Checklists </a> </li>
                                <li className="add-resources"><a onClick={toggleClass} activeClassName='is-active' className="nav-links" href="https://in.accenture.com/protectingaccenture/is-to-operations/threat-response/" target="_blank"> Security Threats List </a> </li>
                                <li className="add-resources"><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/upcoming-events"> Upcoming Events </NavLink> </li>
                                <li className="add-resources"><NavLink onClick={toggleClass} activeClassName='is-active' className="nav-links" to="/faq"> FAQ </NavLink> </li>
                            </ul>
                        </li>
                    </ul>
                    </nav>     
                </div>   
            </div>
	    </div>
    </header>
    )
}
export default Navbarmenu